var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisibleOnFeatureSwitch
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isVisible,
              expression: "isVisible"
            }
          ],
          class: [
            "notification-block",
            _vm.disabled && "is-disabled",
            ..._vm.stateClassList
          ],
          attrs: { disabled: _vm.disabled, "data-testid": "notification-block" }
        },
        [
          _c("div", { staticClass: "notification-block__body" }, [
            _vm.iconClassName
              ? _c(
                  "div",
                  {
                    staticClass: "notification-block__body-icon",
                    attrs: { "data-testid": "notification-block-icon" }
                  },
                  [_c("i", { staticClass: "icon", class: _vm.iconClassName })]
                )
              : _vm._e(),
            _c("div", { staticClass: "notification-block__body-group" }, [
              _vm.title
                ? _c(
                    "span",
                    {
                      staticClass: "notification-block__body-title",
                      attrs: { "data-testid": "notification-block-header" }
                    },
                    [_vm._v(" " + _vm._s(_vm.title) + " ")]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "notification-block__body-text",
                  attrs: { "data-testid": "notification-block-body" }
                },
                [_vm._t("default")],
                2
              )
            ]),
            _vm.$slots["btnSlot"] != undefined
              ? _c(
                  "div",
                  { staticClass: "notification-block__body-action" },
                  [_vm._t("btnSlot")],
                  2
                )
              : _vm._e(),
            _vm.closeBtn
              ? _c(
                  "button",
                  {
                    ref: "closeButton",
                    staticClass: "notification-block__close-btn",
                    on: { click: _vm.onClose }
                  },
                  [_c("i", { staticClass: "icon icon-remove" })]
                )
              : _vm._e()
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }